// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field-group-container .is-grouped-multiline{flex-wrap:nowrap!important;justify-content:space-between}@media screen and (max-width:768px){.field-group-container .is-grouped-multiline .layout-search{flex-wrap:wrap!important;gap:10px}}@media screen and (max-width:768px){.field-group-container .is-grouped-multiline{flex-wrap:wrap!important}}.field-group-container .input-search input{border:1px solid #7d7d7d!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
